import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _typeof from "@babel/runtime/helpers/typeof";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { SSRPlaceholderHandlers } from '../vc-observer/observers/ssr-placeholders';
import EntriesTimeline from './entries-timeline';
import _getElementName from './get-element-name';
import VCCalculator_FY25_03 from './metric-calculator/fy25_03';
import getViewportHeight from './metric-calculator/utils/get-viewport-height';
import getViewportWidth from './metric-calculator/utils/get-viewport-width';
import ViewportObserver from './viewport-observer';
import WindowEventObserver from './window-event-observer';
var SSRState = {
  normal: 1,
  waitingForFirstRender: 2,
  ignoring: 3
};
var DEFAULT_SELECTOR_CONFIG = {
  id: false,
  testId: true,
  role: false,
  className: false,
  dataVC: true
};
var VCObserverNew = /*#__PURE__*/function () {
  function VCObserverNew(config) {
    var _config$isPostInterac,
      _config$selectorConfi,
      _this = this;
    _classCallCheck(this, VCObserverNew);
    _defineProperty(this, "viewportObserver", null);
    _defineProperty(this, "windowEventObserver", null);
    // SSR related properties
    _defineProperty(this, "ssrPlaceholderHandler", null);
    _defineProperty(this, "ssr", {
      state: SSRState.normal,
      reactRootElement: null,
      renderStart: -1,
      renderStop: -1
    });
    this.entriesTimeline = new EntriesTimeline();
    this.isPostInteraction = (_config$isPostInterac = config.isPostInteraction) !== null && _config$isPostInterac !== void 0 ? _config$isPostInterac : false;
    this.selectorConfig = (_config$selectorConfi = config.selectorConfig) !== null && _config$selectorConfi !== void 0 ? _config$selectorConfi : DEFAULT_SELECTOR_CONFIG;

    // Use shared SSR placeholder handler if provided, otherwise create new one if feature flag is enabled
    if (config.ssrPlaceholderHandler) {
      this.ssrPlaceholderHandler = config.ssrPlaceholderHandler;
    } else {
      var _config$SSRConfig$ena, _config$SSRConfig, _config$SSRConfig$dis, _config$SSRConfig2;
      this.ssrPlaceholderHandler = new SSRPlaceholderHandlers({
        enablePageLayoutPlaceholder: (_config$SSRConfig$ena = (_config$SSRConfig = config.SSRConfig) === null || _config$SSRConfig === void 0 ? void 0 : _config$SSRConfig.enablePageLayoutPlaceholder) !== null && _config$SSRConfig$ena !== void 0 ? _config$SSRConfig$ena : false,
        disableSizeAndPositionCheck: (_config$SSRConfig$dis = (_config$SSRConfig2 = config.SSRConfig) === null || _config$SSRConfig2 === void 0 ? void 0 : _config$SSRConfig2.disableSizeAndPositionCheck) !== null && _config$SSRConfig$dis !== void 0 ? _config$SSRConfig$dis : {
          v: false,
          h: false
        }
      });
    }
    this.viewportObserver = new ViewportObserver({
      onChange: function onChange(onChangeArg) {
        var time = onChangeArg.time,
          type = onChangeArg.type,
          elementRef = onChangeArg.elementRef,
          visible = onChangeArg.visible,
          rect = onChangeArg.rect,
          previousRect = onChangeArg.previousRect,
          mutationData = onChangeArg.mutationData;
        var elementName = 'unknown';
        var element = elementRef.deref();
        if (element) {
          elementName = _this.getElementName(element);
        }
        _this.entriesTimeline.push({
          time: time,
          data: {
            type: type,
            elementName: elementName,
            rect: rect,
            previousRect: previousRect,
            visible: visible,
            attributeName: mutationData === null || mutationData === void 0 ? void 0 : mutationData.attributeName,
            oldValue: mutationData === null || mutationData === void 0 ? void 0 : mutationData.oldValue,
            newValue: mutationData === null || mutationData === void 0 ? void 0 : mutationData.newValue
          }
        });
      },
      // Pass SSR context to ViewportObserver
      getSSRState: function getSSRState() {
        return _this.getSSRState();
      },
      getSSRPlaceholderHandler: function getSSRPlaceholderHandler() {
        return _this.getSSRPlaceholderHandler();
      }
    });
    this.windowEventObserver = new WindowEventObserver({
      onEvent: function onEvent(_ref) {
        var time = _ref.time,
          type = _ref.type;
        _this.entriesTimeline.push({
          time: time,
          data: {
            type: 'window:event',
            eventType: type
          }
        });
      }
    });
  }
  return _createClass(VCObserverNew, [{
    key: "start",
    value: function start(_ref2) {
      var _this$viewportObserve,
        _window,
        _this2 = this,
        _this$windowEventObse;
      var startTime = _ref2.startTime;
      // Reset SSR state on start (matches old VCObserver behavior)
      this.ssr = {
        state: SSRState.normal,
        reactRootElement: null,
        // Reset to null (matches old VCObserver)
        renderStart: -1,
        renderStop: -1
      };
      (_this$viewportObserve = this.viewportObserver) === null || _this$viewportObserve === void 0 || _this$viewportObserve.start();
      if ((_window = window) !== null && _window !== void 0 && _window.__SSR_ABORT_LISTENERS__) {
        var abortListeners = window.__SSR_ABORT_LISTENERS__;
        var aborts = abortListeners.aborts;
        if (aborts && _typeof(aborts) === 'object') {
          Object.entries(aborts).forEach(function (_ref3) {
            var _ref4 = _slicedToArray(_ref3, 2),
              key = _ref4[0],
              time = _ref4[1];
            if (typeof time === 'number') {
              _this2.entriesTimeline.push({
                time: time,
                data: {
                  type: 'window:event',
                  eventType: key
                }
              });
            }
          });
        }
      }
      (_this$windowEventObse = this.windowEventObserver) === null || _this$windowEventObse === void 0 || _this$windowEventObse.start();
      this.entriesTimeline.clear();
    }
  }, {
    key: "stop",
    value: function stop() {
      var _this$viewportObserve2, _this$windowEventObse2;
      (_this$viewportObserve2 = this.viewportObserver) === null || _this$viewportObserve2 === void 0 || _this$viewportObserve2.stop();
      (_this$windowEventObse2 = this.windowEventObserver) === null || _this$windowEventObse2 === void 0 || _this$windowEventObse2.stop();

      // Clear SSR state on stop (matches old VCObserver behavior)
      this.ssr.reactRootElement = null;
    }

    // SSR related methods
  }, {
    key: "setReactRootElement",
    value: function setReactRootElement(element) {
      this.ssr.reactRootElement = element;
    }
  }, {
    key: "setReactRootRenderStart",
    value: function setReactRootRenderStart() {
      var startTime = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : performance.now();
      this.ssr.renderStart = startTime;
      this.ssr.state = SSRState.waitingForFirstRender;
    }
  }, {
    key: "setReactRootRenderStop",
    value: function setReactRootRenderStop() {
      var stopTime = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : performance.now();
      this.ssr.renderStop = stopTime;
    }
  }, {
    key: "collectSSRPlaceholders",
    value: function collectSSRPlaceholders() {
      // This is handled by the shared SSRPlaceholderHandlers in VCObserverWrapper
      // Individual observers don't need to implement this
    }

    // Internal methods for ViewportObserver to access SSR state
  }, {
    key: "getSSRState",
    value: function getSSRState() {
      return this.ssr;
    }
  }, {
    key: "getSSRPlaceholderHandler",
    value: function getSSRPlaceholderHandler() {
      return this.ssrPlaceholderHandler;
    }
  }, {
    key: "addSSR",
    value: function addSSR(ssr) {
      this.entriesTimeline.push({
        time: ssr,
        data: {
          elementName: 'SSR',
          type: 'mutation:element',
          rect: {
            height: getViewportHeight(),
            width: getViewportWidth(),
            left: 0,
            top: 0,
            x: 0,
            y: 0,
            bottom: getViewportHeight(),
            right: getViewportWidth(),
            toJSON: function toJSON() {
              return null;
            }
          },
          visible: true
        }
      });
    }
  }, {
    key: "getVCResult",
    value: function () {
      var _getVCResult = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(param) {
        var start, stop, interactionId, results, calculator_fy25_03, orderedEntries, fy25_03;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              start = param.start, stop = param.stop, interactionId = param.interactionId;
              results = [];
              this.addStartEntry(start);
              calculator_fy25_03 = new VCCalculator_FY25_03();
              if (param.ssr) {
                this.addSSR(param.ssr);
              }
              orderedEntries = this.entriesTimeline.getOrderedEntries({
                start: start,
                stop: stop
              });
              _context.next = 8;
              return calculator_fy25_03.calculate({
                orderedEntries: orderedEntries,
                startTime: start,
                stopTime: stop,
                interactionId: interactionId,
                isPostInteraction: this.isPostInteraction
              });
            case 8:
              fy25_03 = _context.sent;
              if (fy25_03) {
                results.push(fy25_03);
              }
              return _context.abrupt("return", results);
            case 11:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function getVCResult(_x) {
        return _getVCResult.apply(this, arguments);
      }
      return getVCResult;
    }()
  }, {
    key: "addStartEntry",
    value: function addStartEntry(startTime) {
      this.entriesTimeline.push({
        time: startTime,
        data: {
          type: 'mutation:element',
          elementName: 'START',
          visible: true,
          rect: {
            x: 0,
            y: 0,
            width: window.innerWidth,
            height: window.innerHeight,
            top: 0,
            left: 0,
            bottom: window.innerHeight,
            right: window.innerWidth,
            toJSON: function toJSON() {
              return {
                x: this.x,
                y: this.y,
                width: this.width,
                height: this.height,
                top: this.top,
                left: this.left,
                bottom: this.bottom,
                right: this.right
              };
            }
          }
        }
      });
    }
  }, {
    key: "getElementName",
    value: function getElementName(element) {
      return _getElementName(this.selectorConfig, element);
    }
  }]);
}();
export { VCObserverNew as default };